import * as React from 'react';
import * as I18n from 'i18n-js';
import FormGroupWithSelect, {
  ISelectOption,
  ISelectOptionGroup,
} from '../components/form_group_with_select';
import { core_apimessages_Country as ICountry } from '../rql';
import { SUBREGION_CODES, subregionName } from './shipping_region';

interface IProps {
  countries: ICountry[];
  onChange: Function;
  value?: string;
}

class ShippingRegionSelector extends React.Component<IProps, {}> {
  get subregionOptions(): ISelectOption[] {
    return SUBREGION_CODES.map((code) => {
      return { text: subregionName(code), value: code };
    });
  }

  countryIsNotUS(country: ICountry) {
    return country.countryCode !== 'US';
  }

  get countryOptions(): ISelectOption[] {
    return this.props.countries.filter(this.countryIsNotUS).map((country: ICountry) => {
      return { text: country.name, value: country.countryCode };
    });
  }

  get optionGroups(): ISelectOptionGroup[] {
    return [
      { options: this.subregionOptions, key: 'subregions' },
      { options: this.countryOptions, key: 'countries' },
    ];
  }

  render() {
    return (
      <FormGroupWithSelect
        id="shippingRegionCode"
        inputName="shippingRegionCode"
        label={I18n.t('commons.offers.location.shippingRegionLabel')}
        updateField={this.props.onChange}
        value={this.props.value || ''}
        required
        addEmptyOption
        optionGroups={this.optionGroups}
        autoFocus
      />
    );
  }
}

export default ShippingRegionSelector;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/offers/shipping_region_selector.tsx